'use client';
import { styled, createGlobalStyle } from 'styled-components';
import { zIndexMap } from '@/util/const';

interface LoadingProps {
  inline?: boolean;
  size?: number;
}

export const LoadingAnimation = createGlobalStyle`
  @keyframes spinLoader {
    100% {
      transform: rotate(1turn);
    }
  }
`;

export default function Loading({ inline = false, size }: LoadingProps) {
  return (
    <>
      <LoadingAnimation />
      {inline ? (
        <InlineLoader size={size} />
      ) : (
        <Container>
          <div className="loader"></div>
        </Container>
      )}
    </>
  );
}

const InlineLoader = styled.div<{ size?: number }>`
  width: ${props => props.size || 24}px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(
        farthest-side,
        var(--node-process, #bea66b) 94%,
        #0000
      )
      top/${props => Math.max(6, (props.size || 24) / 4)}px ${props => Math.max(6, (props.size || 24) / 4)}px no-repeat,
    conic-gradient(#0000 00%, var(--node-process, #bea66b));
  mask: radial-gradient(farthest-side, #0000 calc(100% - ${props => Math.max(6, (props.size || 24) / 4)}px), #000 0);
  animation: spinLoader 1s infinite linear;
  display: inline-block;
  vertical-align: middle;
`;

const Container = styled.div`
  background: var(--background-primary, #ffffff);
  opacity: 0.8;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: ${zIndexMap.loading};
  position: fixed;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  .loader {
    width: 64px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: radial-gradient(
          farthest-side,
          var(--node-process, #bea66b) 94%,
          #0000
        )
        top/15px 15px no-repeat,
      conic-gradient(#0000 00%, var(--node-process, #bea66b));
    mask: radial-gradient(farthest-side, #0000 calc(100% - 15px), #000 0);
    animation: spinLoader 1s infinite linear;
  }
`;
